import React from 'react';
import { Tooltip } from 'flowbite-react';
import moment from 'moment';
import { InfoIcon } from '../../../theme/icons';
import PropTypes from 'prop-types';

const LastSyncedInfo = ({ 
    lastSyncedTime, 
    tooltipContent = "To update your data, click on 'sync now' under the 3-dot menu.",
    title = "Data updated on"
}) => {
    if (!lastSyncedTime) return null;

    return (
        <div className='flex flex-col items-start justify-start gap-1'>
            <span className='font-semibold text-left text-sm text-secondary-400 flex gap-3 items-center'>
                {title}
                <Tooltip 
                    theme={{
                        content: "w-64 break-words whitespace-normal"
                    }} 
                    content={tooltipContent}
                >
                    <InfoIcon className='cursor-pointer' />
                </Tooltip>
            </span>
            <span className='font-thin text-secondary-600'>
                {moment(lastSyncedTime)?.format('DD/MM/YYYY hh:mm A')}
            </span>
        </div>
    );
};

LastSyncedInfo.propTypes = {
    lastSyncedTime: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    tooltipContent: PropTypes.string,
    title: PropTypes.string
};

export default LastSyncedInfo; 